import { LOGIN, LOGOUT, LOGIN_FAILURE as ERROR, CHECK } from '@/state/types/auth'

// Authenticated by default
export default (type, params) => {
  if (type === LOGIN) {
    const { email, password } = params
    const request = new Request(`${process.env.API_URL}/api/auth`, {
      method: 'POST',
      body: JSON.stringify({ email, password }),
      credentials: 'include',
      headers: new Headers({ 'Content-Type': 'application/json' }),
    })
    return fetch(request)
      .then(response => {
        if (response.status < 200 || response.status >= 300) {
          throw new Error(response.statusText)
        }
        return response.json()
      })
      .then(res => {
        localStorage.setItem('token', res.token)
        return res
      })
  }
  if (type === LOGOUT) {
    localStorage.removeItem('token')
    return Promise.resolve()
  }
  if (type === ERROR) {
    const { status } = params
    return status === 401 || status === 403 ? Promise.reject() : Promise.resolve()
  }
  if (type === CHECK) {
    return localStorage.getItem('token') ? Promise.resolve() : Promise.reject()
  }
  return Promise.reject('Unknown method')
}



// WEBPACK FOOTER //
// ./api/authClient.js